<med-notification-item
  *ngFor="let item of list; let i = index"
  [index]="i"
  [notification]="item"
  [closable]="closable"
  [lifeTime]="lifeTime"
  [template]="template"
  [position]="position"
  (close)="onNotificationClose($event)"
></med-notification-item>
